import { FactoryProvider, InjectionToken } from '@angular/core';

export const WINDOW = new InjectionToken<Window>('WindowToken');

export function windowFactory(): Window | undefined {
  return typeof window !== 'undefined' ? window : undefined;
}

export const WINDOW_PROVIDER: FactoryProvider = {
  provide: 'WINDOW',
  useFactory: windowFactory,
};
